/**
 * The Origin Event's two shops (spec docs/superpowers/specs/2026-10-12-origin-shops-and-heavens-peak-design.md,
 * Light Shop: 2026-10-13-light-orb-chests-light-shop-design.md).
 *
 * The Dark Shop, under The Dark Shadows' card, sells three towers for Dark
 * Hambi Coins; the Light Shop, under Above the Clouds', three for Light Hambi
 * Coins. A bought tower is owned for good (`hambi.owned`, which already syncs)
 * and is on the roster everywhere, like a Shop purchase — but it is sold on no
 * other shelf, and `VARIETY_ORB_TOWERS` subtracts it.
 */
import type { ShopTowerType } from './unlocks';

export type OriginShopId = 'dark' | 'light';

export const DARK_SHOP_TOWERS = [
  'horror',
  'demonic',
  'hamreaper',
] as const satisfies readonly ShopTowerType[];
export type DarkShopTower = (typeof DARK_SHOP_TOWERS)[number];

/** Prices in Dark Hambi Coins (the brief's). */
export const DARK_SHOP_PRICES: Record<DarkShopTower, number> = {
  horror: 100,
  demonic: 300,
  hamreaper: 500,
};

export const LIGHT_SHOP_TOWERS = [
  'healer',
  'banker',
  'angelic',
] as const satisfies readonly ShopTowerType[];
export type LightShopTower = (typeof LIGHT_SHOP_TOWERS)[number];

/** Prices in Light Hambi Coins (the brief's). */
export const LIGHT_SHOP_PRICES: Record<LightShopTower, number> = {
  healer: 100,
  banker: 300,
  angelic: 500,
};

/** Every tower either Origin shop sells. */
export type OriginShopTower = DarkShopTower | LightShopTower;

/** One shop's shelf: what it sells, and for how much of its own currency. */
export function originShopShelf(shop: OriginShopId): {
  towers: readonly OriginShopTower[];
  prices: Record<string, number>;
} {
  return shop === 'dark'
    ? { towers: DARK_SHOP_TOWERS, prices: DARK_SHOP_PRICES }
    : { towers: LIGHT_SHOP_TOWERS, prices: LIGHT_SHOP_PRICES };
}

export function isDarkShopTower(t: string): t is DarkShopTower {
  return (DARK_SHOP_TOWERS as readonly string[]).includes(t);
}

export function isLightShopTower(t: string): t is LightShopTower {
  return (LIGHT_SHOP_TOWERS as readonly string[]).includes(t);
}
